export function convertField(str: string, repAll: boolean): string {
  if(repAll){
    return str.replace(/\./g, '_')
  }
  // 找到第一个点号的位置
  const firstDotIndex = str.indexOf('.');
  if (firstDotIndex !== -1) {
    // 将字符串分割为两部分：第一个点号前面的部分和后面的部分
    const beforeFirstDot = str.substring(0, firstDotIndex);
    const afterFirstDot = str.substring(firstDotIndex + 1);
    // 将后面的部分中的点号替换为下划线
    const convertedAfterFirstDot = afterFirstDot.replace(/\./g, '_');
    // 拼接两部分字符串
    return beforeFirstDot + '.' + convertedAfterFirstDot;
  }

  return str;
}


type OverloadFunction = (...args: any[]) => any;

export function createOverload(): OverloadFunction {
  const finalMap = new Map<string, OverloadFunction>();

  function overload(...args: any[]): any {
    const key = args.map((arg) => typeof arg).join(',');
    const fn = finalMap.get(key);

    if (!fn) {
      throw new TypeError('没有找到这个方法');
    }
    // @ts-ignore
    return fn.apply(this, args);
  }

  overload.addImpl = function (...args: any[]): void {
    const fn = args.pop();

    if (typeof fn !== 'function') {
      throw new TypeError('最后一个参数必须是方法');
    }

    const key = args.join(',');
    finalMap.set(key, fn);
  };

  return overload;
}
